import React from 'react';
import './Home.css';
import { useEffect } from "react";

const Review = () => {
  useEffect(() => {
    const script = document.createElement("script");

    script.src =
      "https://cdn.featurable.com/widget/v2/embed.js";

    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="reviwes" id="featurable-5ea8d28e-2fda-44ed-b5ae-822770734a20" data-featurable-async="true"/>
  );
}

export default Review



